/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractReviewerBasicInfo = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
      isRequired: true,
    },
    userId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
